import React, { useRef, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaLocationDot } from "react-icons/fa6";
import { FaPhoneAlt } from "react-icons/fa";
import { IoIosMailUnread } from "react-icons/io";
import Notiflix from "notiflix";
import PostApiCall from "../../helpers/PostApi";
import ReCAPTCHA from "react-google-recaptcha";
const ConttactUsForm = () => {
  const recaptchaRef = useRef(null);
  const [token, setToken] = useState(null);
  const emailRagex = /^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]+\.){1,2}[a-zA-Z]{2,4}$/;
  const [formValue, setFormValue] = useState({
    name: "",
    email: "",
    mobile: "",
    subject: "",
    message: "",
  });
  const handleResetCaptcha = () => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
  };
  const captchaVerify = (value) => {
    setToken(value);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;
    if (name === "mobile") {
      newValue = value.replace(/[^0-9]/g, "").slice(0, 12);
    }
    setFormValue((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const htmlMailer =
    '<html><head><meta charset="utf-8"><title>SREEHARI DIAMOND LABORATORY | ENQUIRY</title></head>' +
    ' <body style="font-family: sans-serif">' +
    ' <div style="width: 100%; margin: auto">' +
    '<div style="text-align: left; margin-bottom: 10px">' +
    '<img style="width: 20%" src="https://sreeharidiamondlab.com/static/media/logo.04f6bad90dcf8391f785.png"/>' +
    "</div>" +
    '<div style="background-color: #8080800d; padding: 20px">' +
    '<h2 style="text-align: left;font-size:14px;color: black;">Dear Sir/Mam, </h2>' +
    "<p style='font-size:14px;color: black;'>You have received an enquiry from the website. The details are as follows:</p>" +
    '<div className="row" style="width: 100%; display: flex">' +
    '<div className="col1" style="width: 30%;display:flex"><b style="color:black">Name</b></div><div style="text-align:center;width: 20%;">-</div>' +
    '<div className="col1" style="width: 50%">' +
    formValue.name +
    "</div>" +
    "</div>" +
    "<br>" +
    '<div className="row" style="width: 100%; display: flex">' +
    '<div className="col1" style="width: 30%;display:flex"><b style="color:black">Mobile Number</b></div><div style="text-align:center;width: 20%;">-</div>' +
    '<div className="col1" style="width: 50%">' +
    formValue.mobile +
    "</div>" +
    "</div>" +
    "<br>" +
    '<div className="row" style="width: 100%; display: flex">' +
    '<div className="col1" style="width: 30%; display: flex"><b style="color:black">Email</b></div><div style="text-align:center;width: 20%;">-</div>' +
    '<div className="col1" style="width: 50%">' +
    formValue.email +
    "</div>" +
    "</div>" +
    "<br>" +
    (formValue.subject
      ? '<div className="row" style="width: 100%; display: flex">' +
      '<div className="col1" style="width: 30%; display: flex"><b style="color:black">Subject</b></div><div style="text-align:center;width: 20%;">-</div>' +
      '<div className="col1" style="width: 50%">' +
      formValue.subject +
      "</div>" +
      "</div>" +
      "<br>"
      : "") +
    (formValue.message
      ? '<div className="row" style="width: 100%; display: flex">' +
      '<div className="col1" style="width: 30%; display: flex"><b style="color:black">Message</b></div><div style="text-align:center;width: 20%;">-</div>' +
      '<div className="col1" style="width: 50%">' +
      formValue.message +
      "</div>" +
      "</div>" +
      "<br>"
      : "") +
    "</div></div>" +
    "</body>" +
    "</html>";

  const submitForm = () => {
    if (!formValue.name) {
      Notiflix.Notify.failure("Please enter your name");
      return;
    } else if (!formValue.email) {
      Notiflix.Notify.failure("Please enter your email address");
      return;
    } else if (!emailRagex.test(formValue.email)) {
      Notiflix.Notify.failure("Please enter valid email address");
      return;
    } else if (!formValue.mobile || (formValue?.mobile?.length < 10)) {
      Notiflix.Notify.failure("Please enter your phone number");
      return;
    } else if (!token) {
      Notiflix.Notify.failure("Please verify captcha");
      return;
    }
    try {
      Notiflix.Loading.dots();
      PostApiCall.postRequest(
        {
          name: formValue.name,
          mobile: formValue.mobile,
          email: formValue.email,
          subject: formValue.subject,
          message: formValue.message,
          mailerHtml: htmlMailer,
          token: token,
        },
        "ContactUs"
      ).then((res) => {
        if (res.status === 200 || res.status === 201) {
          setFormValue({
            name: "",
            email: "",
            mobile: "",
            subject: "",
            message: "",
          });
          handleResetCaptcha();
          setToken(null);
          Notiflix.Loading.remove();
          Notiflix.Notify.success("Form submitted successfully");
        } else {
          handleResetCaptcha();
          setToken(null);
          Notiflix.Loading.remove();
        }
      });
    } catch (err) {
      console.log(err);
      handleResetCaptcha();
      setToken(null);
      Notiflix.Loading.remove();
    }
  };
  return (
    <section className="section-spacing-x section-spacing-y">
      <Container fluid>
        <Row>
          <Col lg={12}>
            <div className="text-center mb-4">
              <h1 className="heading">Get In Touch With Us!</h1>
            </div>
          </Col>
          <Col lg={6} className="order-lg-1 order-2 mt-lg-0 mt-4">
            <h3>Contact Info</h3>
            <div className="contact-address">
              <a
                href="https://maps.app.goo.gl/w8R7Ee74imr1L3QEA"
                target="_blank"
                className="d-flex align-items-center gap-2"
              >
                <span className="contact-icon">
                  {" "}
                  <FaLocationDot />
                </span>
                <span>
                  <b>SREEHARI DIAMOND LABORATORY</b> <br />
                  No 3/11 Opposite to Union Bank of India, <br />
                  Kunjan Chettiyar Street, KaraiKudi, <br /> Sivaganga - 630
                  001, Tamil Nadu, INDIA.
                </span>
              </a>
            </div>

            <div className="contact-address mt-3">
              <a
                href="tel:+919443736692"
                className="d-flex align-items-center gap-2"
              >
                <span className="contact-icon">
                  {" "}
                  <FaPhoneAlt />
                </span>
                +91 94437 36692
              </a>
            </div>

            <div className="contact-address mt-3">
              <a
                href="tel:+919442101562"
                className="d-flex align-items-center gap-2"
              >
                <span className="contact-icon">
                  {" "}
                  <FaPhoneAlt />
                </span>
                +91 94421 01562
              </a>
            </div>

            <div className="contact-address mt-3">
              <a
                href="mailto:sreeharidiamondlab@gmail.com "
                className="d-flex align-items-center gap-2"
              >
                <span className="contact-icon mail-icon">
                  {" "}
                  <IoIosMailUnread />
                </span>
                sreeharidiamondlab@gmail.com{" "}
              </a>
            </div>
          </Col>
          <Col lg={6} className="form order-lg-2 order-1">
            <h4 className="heading text-start mb-0">
              Welcome to <br className="d-md-none" /> SREEHARI DIAMOND
              LABORATORY!
            </h4>
            <p>
              Have questions or need assistance? Contact Sreehari Diamond
              Laboratory today for expert support on diamond testing and
              certification. We are here to help you with trusted, timely, and
              professional service.
            </p>
            <Form className="conatctus-form">
              <Form.Group className="mb-3 form-inputs">
                <Form.Control
                  type="text"
                  name="name"
                  value={formValue.name}
                  placeholder="Enter your name*"
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3 form-inputs">
                <Form.Control
                  type="text"
                  name="email"
                  value={formValue.email}
                  placeholder="Enter your email address*"
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3 form-inputs">
                <Form.Control
                  type="text"
                  name="mobile"
                  value={formValue.mobile}
                  placeholder="Enter your mobile number*"
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3 form-inputs">
                <Form.Control
                  type="text"
                  name="subject"
                  value={formValue.subject}
                  placeholder="Enter subject"
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3 form-inputs">
                <Form.Control
                  as="textarea"
                  name="message"
                  rows={5}
                  value={formValue.message}
                  placeholder="Type your message here..."
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>
              <ReCAPTCHA
                sitekey="6LcAbmIrAAAAAA3cVWVr9QtRXY4TelU57UbBMDFp"
                onChange={captchaVerify}
                ref={recaptchaRef}
              />

              <div className="text-end send">
                <Button
                  type="button"
                  variant="light"
                  className="offcan-logout-btn mt-lg-0 mt-4"
                  onClick={submitForm}
                >
                  Submit
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ConttactUsForm;
